export default {
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen,
    isProtocolFormOpen: state => state.protocolFormIsOpen,
    isProtocolGridOpen: state => state.protocolGridIsOpen,

    getDataTableOptions: state => state.dataTableOptions,
    getActions: state => state.actions,
    getFormActions: state => state.formActions,
    getRowActions: state => state.rowActions,
    getHeaderFields: state => state.headerFields,

    getProtocolDataTableOptions: state => state.protocolDataTableOptions,
    getProtocolActions: state => state.protocolActions,
    getProtocolFormActions: state => state.protocolFormActions,
    getProtocolRowActions: state => state.protocolRowActions,
    getProtocolHeaderFields: state => state.protocolHeaderFields,

    getProtocolSelectDataTableOptions: state => state.protocolSelectDataTableOptions,
    getProtocolSelectRowActions: state => state.protocolSelectRowActions,
    getProtocolSelectActions: state => state.protocolSelectActions,
    getProtocolSelectHeaderFields: state => state.protocolSelectHeaderFields
}
